var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:({
    width: '100%',
    height: `${_vm.screeHeight}px`,
    overflow: 'hidden',
    backgroundImage: 'url(' + (_vm.bgContent ? _vm.bgContent : '') + ')',
    backgroundSize: '100% 100%',
  })},[_c('div',{staticStyle:{"overflow-y":"auto","height":"100%"}},[(_vm.levelData.type == 'livesFrameList')?_c('div',{staticStyle:{"position":"relative","display":"flex","flex-wrap":"wrap","padding-top":"10px","justify-content":"center"}},_vm._l((_vm.levelData.list),function(childItem,key){return _c('img',{key:key,style:({
          border:
            _vm.levelData.showBorder == 2
              ? '2px solid #FFF'
              : _vm.levelData.showBorder == 1
              ? '2px solid #000'
              : '0px',
          width: 'calc(50% - 20px)',
          marginLeft: key % 2 == 1 ? '10px' : '0px',
          marginBottom: '10px',
          height: '98px',
        }),attrs:{"src":childItem.cover},on:{"click":function($event){return _vm.goToDetail('live', childItem.id)}}})}),0):_vm._e(),(_vm.levelData.type == 'videosFrameList')?_c('div',{style:({
        display: 'flex',
        'justify-content': 'center',
        'align-items': 'center',
      })},[_c('videosItem',{attrs:{"newsList":_vm.levelData.list,"showBorder":_vm.levelData.showBorder}})],1):_vm._e(),(_vm.levelData.type == 'newsFrameList')?_c('div',[_c('newsItem',{attrs:{"newsList":_vm.levelData.list,"showBorder":_vm.levelData.showBorder}})],1):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }